<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card>
      <ib-dialog-header title="Finalizar conversas em massa" subtitle="Finalize várias conversas de uma vez através do tempo de inatividade. Por exemplo, ao selecionar 48 horas, todas as conversas que não trocaram nenhuma mensagem nesse período serão finalizadas." :close="closeDialog"></ib-dialog-header>


      <v-card-text>
        <v-row>
          <v-col cols="12">
            <ib-text-field v-model="hours" label="Horas de inatividade" hide-details="auto" type="number" messages="Quanto menor o tempo, mais conversas serão finalizadas. Tenha cuidado." outlined />
          </v-col>
          
          <v-col cols="12">
            <v-switch v-model="useFilters" inset label="Usar filtros ativos da tela de atendimento" hide-details="auto" />
          </v-col>

          <v-col v-if="useFilters && hasActiveFilters" cols="12">
            <v-card outlined class="pa-3" style="border-radius: 9px;">
              <div class="text-subtitle-2 mb-2">Filtros que serão aplicados:</div>
              <v-chip v-if="filterSummary.types" small class="ma-1">{{ filterSummary.types }}</v-chip>
              <v-chip v-if="filterSummary.departments" small class="ma-1">{{ filterSummary.departments }}</v-chip>
              <v-chip v-if="filterSummary.tags" small class="ma-1">{{ filterSummary.tags }}</v-chip>
              <v-chip v-if="filterSummary.chips" small class="ma-1">{{ filterSummary.chips }}</v-chip>
              <v-chip v-if="filterSummary.situation" small class="ma-1">{{ filterSummary.situation }}</v-chip>
              <div v-if="!hasActiveFilters" class="text-caption grey--text mt-2">Nenhum filtro ativo</div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <ib-btn color="gray200" outlined @click="closeDialog">
          <div class="gray1000--text">
            Cancelar
          </div>
        </ib-btn>
        <v-spacer />
        <ib-btn color="primary" :loading="loading" @click="finishInactiveConversations">
          Finalizar conversas
        </ib-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    activeFilters: {
      type: Object,
      default: () => ({})
    },
    preFilters: {
      type: Object,
      default: () => ({})
    },
    tags: {
      type: Array,
      default: () => []
    },
    departments: {
      type: Array,
      default: () => []
    },
    chips: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      hours: 48,
      useFilters: false
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    currentUser() {
      return this.$store.state.currentUser;
    },

    hasActiveFilters() {
      const situationId = typeof this.preFilters.situation === 'object' ? this.preFilters.situation?.id : this.preFilters.situation;
      
      return this.preFilters.departments?.length > 0 ||
        this.preFilters.tags?.length > 0 ||
        this.preFilters.chips?.length > 0 ||
        this.preFilters.types?.length !== 2 ||
        (situationId && situationId !== 'all');
    },

    filterSummary() {
      const summary = {};

      if (this.preFilters.types && this.preFilters.types.length === 1) {
        summary.types = `Tipo: ${this.preFilters.types[0].name}`;
      }

      if (this.preFilters.departments?.length > 0) {
        const names = this.preFilters.departments.map(d => d.name).join(', ');
        summary.departments = `Departamentos: ${names}`;
      }

      if (this.preFilters.tags?.length > 0) {
        const names = this.preFilters.tags.map(t => t.name).join(', ');
        summary.tags = `Tags: ${names}`;
      }

      if (this.preFilters.chips?.length > 0) {
        const names = this.preFilters.chips.map(c => c.name).join(', ');
        summary.chips = `Chips: ${names}`;
      }
      
      if (this.preFilters.situation) {
        this.preFilters.situation.name != 'Todas' ? summary.situation = `Situação: ${this.preFilters.situation.name}` : summary.situation = 'Situação: Todas';
      }

      return summary;
    }
  },
  methods: {
    clear() {
      this.hours = 48;
      this.useFilters = false;
    },

    closeDialog() {
      this.clear();
      this.dialog = false;
    },

    async finishInactiveConversations() {
      this.loading = true;
      
      const payload = { hours: this.hours };
      
      if (this.useFilters) {
        payload.filter = {};
        
        if (this.preFilters.types && this.preFilters.types.length === 1) payload.filter.is_manual = this.preFilters.types[0].id === 'human';
        
        if (this.preFilters.departments?.length > 0) payload.filter.departments = this.preFilters.departments.map(d => d._id);
        
        if (this.preFilters.tags?.length > 0) payload.filter.tags = this.preFilters.tags.map(t => t._id);
        
        if (this.preFilters.chips?.length > 0) payload.filter.chips = this.preFilters.chips.map(c => c._id);

        if (this.preFilters.situation?.name != 'Todas') payload.filter.waiting_response = true;
      }
      
      const resp = await this.$api.finishInactiveConversations(payload);
      this.loading = false;

      if (!resp.error && resp.message) {
        this.$toast("success", "Conversas finalizadas com successo!");
        this.closeDialog();
      }
    },
  }
};
</script>

<style>
.status-label {
  font-size: 16px;
  font-weight: 500;
  margin-top: 12px;
}
</style>